export const ALL_REWARDS_ADMIN_ENDPOINTS = {
  GET_ALL_ACTIVITY: 'api/v1/badge/assignments/admin/all-activity',
  GET_ALL_REWARDS: 'api/v1/badge/assignments/admin/all-rewards',
  EXPORT_ALL_REWARD_CSV: 'api/v1/badge/assignments/admin/all-activity/download'
}